import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const ResetPassword = () => {
  const query = useQuery();
  const token = query.get('token') || '';
  const navigate = useNavigate();
  const { appLoading, isAuthenticated } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!appLoading && isAuthenticated) navigate('/gestion-budget/dashboard', { replace: true });
  }, [appLoading, isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!token) { setError('Lien invalide. Le token est manquant.'); return; }
    if (!password || !confirm) { setError('Veuillez remplir tous les champs.'); return; }
    if (password.length < 8) { setError('Le mot de passe doit contenir au moins 8 caractères.'); return; }
    if (password !== confirm) { setError('Les mots de passe ne correspondent pas.'); return; }
    setSubmitting(true);
    try {
      await authAPI.resetPassword({ token, password });
      setMessage('Votre mot de passe a été réinitialisé avec succès.');
    } catch (err) {
      const msg = err?.response?.data?.message || 'Impossible de réinitialiser le mot de passe.';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-root">
      <div className="auth-card">
        <div className="auth-card-inner">
          <div className="auth-logo">
            <img src="/dub-hub-logo.svg" alt="Dub Gestion Hub" className="auth-logo-dub" />
          </div>
          <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, textAlign: 'center' }}>Nouveau mot de passe</h3>
          {!token && <div className="auth-error" style={{ marginBottom: 16 }}>Lien invalide. Demandez un nouveau lien depuis la connexion.</div>}
          {error && <div className="auth-error" style={{ marginBottom: 16 }}>{error}</div>}
          {message && <div className="auth-success" style={{ marginBottom: 16 }}>{message}</div>}
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="field-group">
              <label className="field-label">Nouveau mot de passe</label>
              <input className="field-input" type="password" placeholder="Au moins 8 caractères" value={password}
                onChange={e => setPassword(e.target.value)} required minLength={8} disabled={submitting} />
            </div>
            <div className="field-group">
              <label className="field-label">Confirmer le mot de passe</label>
              <input className="field-input" type="password" placeholder="Répétez le mot de passe" value={confirm}
                onChange={e => setConfirm(e.target.value)} required minLength={8} disabled={submitting} />
            </div>
            <button type="submit" className={`btn-primary full${submitting ? ' loading' : ''}`} disabled={submitting || !token}>
              {submitting ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
            </button>
          </form>
          {message && (
            <div className="auth-switch" style={{ marginTop: 16 }}>
              <button type="button" className="link-btn" onClick={() => navigate('/login')}>
                → Aller à la connexion
              </button>
            </div>
          )}
          <div className="auth-switch" style={{ marginTop: 12 }}>
            <button type="button" className="link-btn" onClick={() => navigate('/login')}>
              ← Retour à la connexion
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
